import { useState } from "react";
import { Env } from "core/utils";
export var useDisableClickOnDrag = function (_a) {
    var createOnMouseDownCallback = _a.createOnMouseDownCallback, createOnClickCallback = _a.createOnClickCallback;
    var _b = useState(null), coords = _b[0], setCoords = _b[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var createHandleMouseDown = function (data) {
        return function (e) {
            e.preventDefault();
            if (Env.isTouch)
                setCoords({ x: e.clientX, y: e.clientY });
            if (createOnMouseDownCallback)
                createOnMouseDownCallback(data)(e);
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var createHandleClick = function (data) {
        return function (event) {
            if (Env.isTouch) {
                var clientX = event.clientX, clientY = event.clientY;
                if (coords === null)
                    return;
                if (coords.x !== clientX || coords.y !== clientY) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                setCoords(null);
            }
            if (createOnClickCallback)
                createOnClickCallback(data)(event);
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var clickHandlers = function (data) { return ({
        handleMouseDown: createHandleMouseDown(data),
        handleClick: createHandleClick(data),
    }); };
    return clickHandlers;
};
